import { Base } from '../base-component';
import './content-focus-displays.component.scss';

export class ContentFocusDisplays extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/content-focus-displays/content-focus-displays.component.ts